module.exports = __webpack_public_path__ + "static/project-19c-697a6a78d04bc1db85219808d7fd3345.png";